<template>
  <div class="mt-4 footervue bg-blue-400">

    <div class="text-center py-2 text-black">
      <router-link tag="a" to="/verein/kontakt" class="text-white" > Kontakt | </router-link>
      <router-link tag="a" to="/impressum" class="text-white" > Impressum | </router-link>
      <a class="text-white" target="_blank" href="https://weissenburgbad.ch/wordpress/wp-login.php"> Login |</a>
      <a class="text-white" target="_blank" href="https://www.nickschnee.ch"> nickschnee.ch </a>
    </div>

  </div>

</template>

<script>
export default {
  name: 'FooterVue',
  props: {

  },
  data() {
    return {
    }
  },
  methods: {

  },
  mounted: function(){

  },

  computed: {


  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
